const STORAGE_KEY = 'recently-viewed-products';
const MAX_PRODUCTS = 20;
let memoryProducts = [];
let storageUnavailable = false;

function normalize(products) {
  if (!Array.isArray(products)) return [];
  return [...new Set(products.map(String).filter((id) => /^[1-9]\d*$/.test(id)))].slice(0, MAX_PRODUCTS);
}

/** Product IDs, newest first. Storage restrictions must never disable search. */
export class RecentlyViewed {
  static getProducts() {
    if (storageUnavailable) return [...memoryProducts];
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      memoryProducts = stored ? normalize(JSON.parse(stored)) : [];
    } catch (error) {
      if (error instanceof SyntaxError) memoryProducts = [];
      else storageUnavailable = true;
      // Private browsing, unavailable storage, or malformed saved data.
    }
    return [...memoryProducts];
  }

  static addProduct(productId) {
    const id = String(productId);
    if (!/^[1-9]\d*$/.test(id)) return;
    memoryProducts = normalize([id, ...this.getProducts().filter((product) => product !== id)]);
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(memoryProducts));
    } catch {
      storageUnavailable = true;
      // Retain the in-memory list when storage is unavailable.
    }
  }

  static clearProducts() {
    memoryProducts = [];
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch {
      storageUnavailable = true;
      // Clearing the in-memory list is sufficient in restricted contexts.
    }
  }
}
